import { Checkbox, ListItem } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import TextField from '@material-ui/core/TextField'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateReelsCategory } from '../../../../api/api'
import { IReelsCategoryUpdate, ReelsCategory } from '../../../../interfaces/tell_me_watch/reelsCategory.types'
import { getDataSetToRedux } from '../../../../utility/getAffirmationAndCategory'

interface Props {
    handleClose: VoidFunction,
    category: ReelsCategory,
    open: boolean,
}

export default function ReelsCategoryUpdateDialog(props: Props) {

    const dispatch = useDispatch();
    const [categoryIsActive, setCategoryIsActive] = useState(props.category.isActive);
    const [categoryIsDefault, setcategoryIsDefault] = useState(props.category.isDefault);
    const [categoryIndex, setCategoryIndex] = useState(props.category.index);
    const [categoryIsPremium, setCategoryIsPremium] = useState(props.category.isPremium);
    const [categoryIsNew, setCategoryIsNew] = useState(false);
    const [categoryName, setCategoryName] = useState(props.category.name);
    const [categoryImage, setCategoryImage] = useState(props.category.image);

    /// Update with new Category
    useEffect(() => {
        setCategoryImage(props.category.image);
        setCategoryIndex(props.category.index);
        setCategoryName(props.category.name)
        setCategoryIsActive(props.category.isActive);
        setcategoryIsDefault(props.category.isDefault);
        setCategoryIsNew(false);
        setCategoryIsPremium(props.category.isPremium);
    }, [props.category])

    const handleClose = () => {
        props.handleClose();
    }

    const handleUpdate = async () => {
        props.handleClose();
        const updatedCategory: IReelsCategoryUpdate = {
            id: props.category.id,
            isActive: categoryIsActive,
            isDefault: categoryIsDefault,
            lastUpdatedTime: categoryIsNew ? Date.now() : props.category.lastUpdatedTime,
            image: categoryImage,
            index: categoryIndex,
            isPremium: categoryIsPremium,
            name: categoryName,
        }
        const response = await updateReelsCategory(updatedCategory);
        await getDataSetToRedux(dispatch);

        if (response.success) {
            alert("SUCCESS")
        } else {
            alert("Error");
            console.log(response.message);
        }
    }


    return (
        <Dialog open={props.open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Update Reel Category</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    You may update fields of {props.category.name}.
                </DialogContentText>


                <TextField
                    autoFocus
                    margin="dense"
                    label="id"
                    type="email"
                    fullWidth
                    value={props.category.id}
                />
                <TextField
                    autoFocus
                    margin="dense"
                    label="name"
                    type="email"
                    fullWidth
                    value={categoryName}
                    onChange={(val) => setCategoryName(val.target.value)}
                />
                <TextField
                    autoFocus
                    margin="dense"
                    label="image"
                    type="email"
                    fullWidth
                    value={categoryImage}
                    onChange={(val) => setCategoryImage(val.target.value)}
                />
                <TextField
                    autoFocus
                    margin="dense"
                    label="index"
                    type="number"
                    fullWidth
                    value={categoryIndex.toString()}
                    onChange={(val) => {
                        try {
                            setCategoryIndex(Number.parseInt(val.target.value))
                        } catch (error) {
                            console.log(error);
                        }
                    }}
                />

                <ListItem>
                    <Checkbox
                        checked={categoryIsPremium}
                        onChange={(val, checked) => setCategoryIsPremium(checked)}
                    />
                    is Premium: {`${categoryIsPremium}`}
                </ListItem>

                <ListItem>
                    <Checkbox
                        checked={categoryIsActive}
                        onChange={(val, checked) => setCategoryIsActive(checked)}
                    />
                    is Active: {`${categoryIsActive}`}
                </ListItem>
                <ListItem>
                    <Checkbox
                        checked={categoryIsDefault}
                        onChange={(val, checked) => setcategoryIsDefault(checked)}
                    />
                    is Default: {`${categoryIsDefault}`}
                </ListItem>
                <ListItem>
                    <Checkbox
                        checked={categoryIsNew}
                        onChange={(val, checked) => setCategoryIsNew(checked)}
                    />
                    is New: {`${categoryIsNew}`}
                </ListItem>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleUpdate} color="primary">
                    Update
                </Button>
            </DialogActions>
        </Dialog >
    )
}